import React from 'react';
import type { Order } from '../../types';

interface PrintTypeModalProps {
  order: Order | null;
  onChoose: (type: 'customer' | 'kitchen') => void;
  onCancel: () => void;
}

const PrintTypeModal: React.FC<PrintTypeModalProps> = ({ order, onChoose, onCancel }) => {
  if (!order) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Print order</h2>
        <p className="text-sm text-gray-600 mb-4">
          Order {order.id}
          {order.tableName || order.tableNumber != null
            ? ` · ${order.tableName || `Table ${order.tableNumber}`}`
            : order.takeawayNumber != null
              ? ` · Takeaway #${order.takeawayNumber}`
              : order.deliveryNumber != null
                ? ` · Delivery #${order.deliveryNumber}`
                : ''}
        </p>
        <p className="text-sm font-medium text-gray-700 mb-3">What do you want to print?</p>
        <div className="space-y-2">
          <button
            type="button"
            onClick={() => onChoose('customer')}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border-2 border-gray-200 hover:border-pink-400 hover:bg-pink-50 text-left transition-colors"
          >
            <span className="text-2xl" aria-hidden>🧾</span>
            <div>
              <span className="block font-semibold text-gray-900">Customer receipt</span>
              <span className="block text-xs text-gray-500">Full order with prices and totals</span>
            </div>
          </button>
          <button
            type="button"
            onClick={() => onChoose('kitchen')}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border-2 border-gray-200 hover:border-amber-400 hover:bg-amber-50 text-left transition-colors"
          >
            <span className="text-2xl" aria-hidden>👨‍🍳</span>
            <div>
              <span className="block font-semibold text-gray-900">Kitchen order</span>
              <span className="block text-xs text-gray-500">Items only (no prices). Additions only if order was already sent.</span>
            </div>
          </button>
        </div>
        <div className="mt-4 pt-3 border-t border-gray-200">
          <button
            type="button"
            onClick={onCancel}
            className="w-full py-2 text-sm font-medium text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintTypeModal;
